export default __webpack_public_path__ + "static/media/compliance-2022.36f5e545.jpg";